<template>
  <div>
    <div class="search-wrapper">
      <span>标题：</span>
      <Input style="width:200px;margin-right:20px;" type="text" v-model="searchValue.title"></Input>
      <Button type="primary" @click="search" style="margin:5px 20px;">搜索</Button>
      <Button type="primary" @click="add" icon="android-add" style="margin:5px 0;">添加</Button>
    </div>
    <add-or-edit 
      :title="popTitle" 
      :current="current" 
      v-model="isShow" 
      @file="(val)=>{current.iconName=val}"
      @cancel="getProjectData"
      @ok="(val) => {current=val;requestData()}">
    </add-or-edit>
    <role-menber v-model="roleMenberShow" :roleList="roleList" :reportId="reportId" @save-success="change_show" ref="roleMenber"></role-menber>
    <Table :columns="columns" :data="formData"></Table>
    <Page :total="pageTotal" :current="currentPage" show-elevator show-total style="margin-top:5px;" @on-change="pageChange"></Page>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import addOrEdit from './addOrEdit'
import roleMenber from './roleMenber'

export default {
  components: {
    addOrEdit,
    roleMenber
  },
  data() {
    return {
      searchValue: {
        title: ''
      },
      currentPage: 1,
      pageTotal: 0,
      columns: [
        {
          title: '标题',
          key: 'title',
          align: 'center',
          width: 160
        },
        {
          title: '图标',
          key: 'iconName',
          align: 'center',
          width: 120,
          render: (h,params) => {
            return h('Img',{
              attrs: {
                src: `https://chinapsp-resource.oss-cn-shenzhen.aliyuncs.com/${params.row.iconUrl}`
              }
            })
          }
        },
        {
          title: '链接',
          key: 'reportSysUrl',
          align: 'center',
        },
        {
          title: '排序',
          key: 'rank',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div',params.index + 1)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 300,
          render: (h,params) => {
            return h('div',[
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    margin: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params)
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    margin: "5px"
                  },
                  on: {
                    click: () => {
                      this.delete(params)
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.roleMenber(params)
                    }
                  }
                },
                "角色人员"
              )
            ])
          }
        },
      ],
      formData: [],
      isShow: false,
      current: {},
      file: {},
      popTitle: '添加',
      roleMenberShow: false,
      roleList: [],
      reportId: 0
    }
  },
  async created() {
    this.getProjectData(1, {}, this.extraQuery)
  },
  methods: {
    async getProjectData(page = 1, queryObj = {}, extraQuery = {}) {
      this.currentPage = page
      let querySear = ''
      let searTitle = queryObj.title ? ` and title.Contains("${queryObj.title}")` : ''
      querySear = searTitle
      querySear = querySear.slice(5)
      let rep = await ajax.get(requestUrls.AbpReportSysSetting.GetPaged, {
        params: {
          filter: querySear,
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      if (rep.data.success) {
        this.formData = rep.data.result.items
        this.pageTotal = rep.data.result.totalCount
      }
    },
    requestData() {
      ajax.post(requestUrls.AbpReportSysSetting.CreateOrUpdate,{
        abpReportSysSetting: this.current
      }).then((res) => {
        if (this.popTitle === '添加') {
          this.current = res.data.result
        }
        this.getProjectData()
        this.$Message.success(`${this.popTitle}成功`)
      })
    },
    search() {
      this.currentPage = 1
      this.getProjectData(1, this.searchValue, this.extraQuery)
    },
    pageChange(page) {
      this.getProjectData(page, this.searchValue, this.extraQuery)
    },
    add() {
      this.popTitle = '添加'
      this.isShow = true
      this.current = {}
    },
    edit(params) {
      this.popTitle = '编辑'
      this.isShow = true
      this.current = params.row
    },
    delete(params) {
      this.popTitle = '删除'
      this.$Modal.confirm({
        title: this.popTitle,
        content: `<p>确定要删除${params.row.title}吗？</p>`,
        okText: '删除',
        cancelText: '取消',
        onOk: () => {
          ajax.delete(requestUrls.AbpReportSysSetting.Delete,{
            params: {
              id: params.row.id
            }
          }).then(() => {
            this.getProjectData()
            this.$Message.success(`${this.popTitle}成功`)
          })
        },
        onCancel: () => {}
      });
    },
    roleMenber(params) {
      this.roleMenberShow = true
      this.reportId = params.row.id
      ajax.get(`${requestUrls.Role.GetAll}?skipCount=0&&maxResultCount=100`).then(res => {
        this.roleList = res.data.result.items
        this.$refs.roleMenber.selected()
      })
    },
    change_show(){
      this.roleMenberShow = false
    }
  }
}
</script>
